export const DEFAULT_LOCALE = "en-US";

// The base path of the Mons application route configured in Monster UI.
// Must match the Path of the route pointing at this app.
// @see https://monster.mons.amazon.dev/applications/HILTBusinessReportingUI
export const MONS_ROUTE_BASE = "/hilt-business-reporting";

export const HOMEPAGE_MESSAGE_BUNDLE_NAME = "pages.homepage";

// The default dashboard + review. dashboardId is a closed enum on the
// service — "fai" is the KFE program's wire id (the program was named FAI
// until 2026-09; published data and API payloads key on the old id, so it
// survived the rename — spec dashboard-rename-kfe-quality). reviewType is
// required on every read operation.
export const WBR_DASHBOARD_ID = "fai";
export const WBR_REVIEW_TYPE = "WBR" as const;

/**
 * Router basename shared by the app router (App.tsx) and pre-mount code that
 * parses the URL (app/bootstrapPrefetch.ts). Behind Mons the app is served
 * under the Monster route path; standalone serves at the domain root.
 * Single source of truth — do not re-derive this rule elsewhere.
 */
export const ROUTER_BASENAME =
  !SERVER_MODE || SERVER_MODE === 'mons' ? MONS_ROUTE_BASE : '';
